//UPDATE  CURRENT TAB ON PROFILE PAGE

export const UPDATE_PROFILE_TAB = 'UPDATE_PROFILE_TAB';
export const updateProfileTab = tab => ({
    type: UPDATE_PROFILE_TAB,
    tab,
});
